import { resourcesKeys } from "./resourcesFiles";

export const getResourceByKey = (key) => {
	if (resourcesKeys[key]) {
		return resourcesKeys[key];
	}
	return;
};
